import { render, staticRenderFns } from "./brand-lift.vue?vue&type=template&id=a5aa3cc8&scoped=true"
import script from "./brand-lift.vue?vue&type=script&lang=js"
export * from "./brand-lift.vue?vue&type=script&lang=js"
import style0 from "./brand-lift.vue?vue&type=style&index=0&id=a5aa3cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5aa3cc8",
  null
  
)

export default component.exports